import { connect } from 'react-redux'
import React, { PureComponent } from 'react'
import Setup from '../../views/setup/Setup'
import withTransition from '../../hoc/Transition'

class SetupConnector extends PureComponent {
	render() {
		return <Setup />
	}
}

export default withTransition(connect(null, null)(SetupConnector))
